<template>

    <m-edit1/>

    <m-factor-6 v-bind='{...{},...{}}' :style='""' class="" ></m-factor-6>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor6 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor6';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor6 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
